import { render } from "./SoftModelInput.vue?vue&type=template&id=d4057c96"
import script from "./SoftModelInput.vue?vue&type=script&lang=js"
export * from "./SoftModelInput.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__